/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


// *********************************** collection page read more and less description ***********************************************************

$.fn.myFunction = function() {
  var moretext = "Show more";
  var lesstext = "Show less";

  // Configure/customize these variables.
  var windowSize = $(window).width();
  if (windowSize >= 1025 && windowSize <= 1440 ) {
    var showChar = 400;
    var ellipsestext = "...";  
  }
  else if (windowSize >  1440 ) {
    var showChar = 435;
    var ellipsestext = "...";  
  }
  else if ( windowSize >769  && windowSize <= 1024 ){
    var showChar = 300;
    var ellipsestext = "...";  
  }
  else if ( windowSize >=520  && windowSize <= 768 ){
    var showChar = 250;
    var ellipsestext = "...";  
  }
  else if ( windowSize >=420  && windowSize <= 519 ){
    var showChar = 180; 
    var ellipsestext = "...";  
  }
  else if ( windowSize >=350  && windowSize <= 419 ){
    var showChar = 170; 
    var ellipsestext = "...";  
  }
  else
  { 
    var showChar = 130; 
    var ellipsestext = "...";  
  }
  $('.more').each(function() {
    var content = $(this).html();
    if(content.length > showChar) {
      var c = content.substr(0, showChar);
      var h = content.substr(showChar, content.length - showChar);
      var html = c + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><a href="" class="morelink1">' + moretext + '</a></span>';
      $(this).html(html);
    }
  }); 
}
$.fn.myFunction(); 
$(document).ready(function() {
  $.fn.myFunction(); 
  $(".morelink2").click(function(e){
    $('.All_desc_here').hide();
    $('.showed_description').show();
 });
  $(".morelink1").click(function(e){
    e.preventDefault();
    $('.All_desc_here').show();
    $('.showed_description').hide();


  });
});
// ***********************************End collection page read more and less description *********************


// ***********************************Product page "STYLE WITH"***********************************************
$(document).ready(function() {
  $(".featured_coursess").flickity({
    "prevNextButtons": true,
    "pageDots": false,
    "wrapAround": false,
    "contain": true,
    "cellAlign": "center",
    "watchCSS": true,
    "dragThreshold": 8,
    "touchVerticalScroll": false,
    "groupCells": true,
    "arrowShape": {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}

  });

});
// *********************************** End Product page "STYLE WITH"********************************************

$(document).ready(function(){
  $(document).on('click','.productt1', function() {
    //     alert();
    var color = $(".productt2 .ProductForm__SelectedValue").text();
    var org_color = color.toLowerCase();
    org_color =org_color.replace(" ", "");
    $(".for_variant_avail_or_no option").each(function(){
      //   console.log("each");
      var variantname = $(this).text();
      if(variantname.indexOf(org_color) != -1){
        // console.log("if");
        var new_variants = variantname.replace(org_color,"");
        //    console.log("new_variants=="+new_variants);
        var availbility = $(this).attr("data-name");
        //    console.log("availbility=="+availbility);

        var new_variants =new_variants;
        //   console.log("new_variants=="+new_variants);
        var org_text =$(".custom_1 .Popover__Value[data-set="+new_variants+"]").text(new_variants+availbility);
      }
    });
  });
});




// collection page size color option js custom start (RB)

$(document).ready(function(){

  //   On Load js start
  var count = 1;
  var sec_count = 1;
  $('.collection-page-custom-color').each(function(){
    var color_name = $(this).find('.ProductItem__ColorSwatchItem input:checked').val();
    $(this).parents('.ProductItem__Info').find('.ProductItem__sizeSwatchList').each(function(){

      var new_count = sec_count+'count'+count;

      $(this).find('li').each(function(){

        var size_name = $(this).find('.size-variant-collection').text();

        var new_custom_combination = size_name+' / '+color_name
//         console.log(new_custom_combination);
        var variant_url = $('.collection-page-nojs-selct-box option[data-name="'+new_custom_combination+'"]').data('href');
//         console.log(variant_url);  
        $(this).find('a').attr('href',variant_url);
        var variant_available_check = $('.collection-page-nojs-selct-box option[data-name="'+new_custom_combination+'"]').data('available');
        if(variant_available_check == 'no'){
          $(this).hide();
          $(this).prev('.size-variant--highphan').hide();
        }else{

          if(new_count ==  sec_count+'count1'){
            $(this).prev('.size-variant--highphan').addClass('available_size-li'); 
          }
          new_count = new_count + 1;
        }
      });
      sec_count = sec_count + 1;
    });
  });
  //   On Load js End

  //   On Click color variant js start

  $('.ProductItem__ColorSwatchItem').click(function(){
   
    $(this).parents('.ProductItem__Info').find('.collection-size-filter-ul .available_size-li').removeClass('available_size-li');
    var color_name = $(this).find('.ColorSwatch__Radio').val();
    $(this).parents('.ProductItem__Info').find('.collection-size-filter-ul li').show();
    $(this).parents('.ProductItem__Info').find('.collection-size-filter-ul .size-variant--highphan').show();
    var count = 1;
    $(this).parents('.ProductItem__Info').find('.ProductItem__sizeSwatchList').each(function(){
      $(this).find('li').each(function(){
        var size_name = $(this).find('.size-variant-collection').text();

        var new_custom_combination = size_name+' / '+color_name
//         console.log(new_custom_combination);
        var variant_url = $('.collection-page-nojs-selct-box option[data-name="'+new_custom_combination+'"]').data('href');
//         console.log(variant_url);  
        $(this).find('a').attr('href',variant_url);
        var variant_available_check = $('.collection-page-nojs-selct-box option[data-name="'+new_custom_combination+'"]').data('available');
        if(variant_available_check == 'no'){
          $(this).hide();
          $(this).prev('.size-variant--highphan').hide();
        }else{

          if(count == '1'){
            $(this).prev('.size-variant--highphan').addClass('available_size-li'); 
          }
          count = count + 1;
        }

      });
    });    
  }); 
  //   On Click color variant js End
if($(".Article__Body.Rte").parent().find('p img').length == 1) {
var date_show =$(".artical_template_center.custom_date_new").html();
$( ".Article__Body.Rte p" ).first().after(date_show);
$(".Article__Content .article__date").addClass("date_show");
$(".artical_template_center.custom_date_new").hide();
}else{
$(".artical_template_center.custom_date_new").show();
}
  $('.ProductItem__Info').each(function(){
            $(this).find(".ProductItem__sizeSwatchList:not(:first)").hide();
          });
});
// collection page size color option js custom End

$(document).ready(function(){
  $(".font_size_color.artical_template_center.custom_date_new").hide();
  var date_update =$(".font_size_color.artical_template_center.custom_date_new").text();
  var html_date="<p class='custm_new_dates'>"+date_update+"</p>";
  $('.Article__Body.Rte p:eq(0)').after(html_date);
});
//Collection Page Sold Product Message

$(document).ready(function(){
$(".collection-page-custom-color .ProductItem__ColorSwatchItem").click(function(){
  console.log('dd');
var id = $(this).attr("data-id");
var color = $(this).find("input").val();
var stock_avil = 0;
var select_box_text= '' ;
var collection_url = window.location.href;
var collection_url_final = collection_url.includes("kids-muay-thai-shorts");
var collection_url_adults = collection_url.includes("carbonfit-muay-thai-shorts");
var collection_url_adultst = collection_url.includes("traditional-muay-thai-shorts");
//  console.log('collection_url_adults', collection_url_adults);
if(collection_url_final == true){
 console.log('child');
$(this).parent().find(".variants-wrapper select option").each(function(){
var name = $(this).text();
//console.log('sssssssss', name);
var child_collection_name = name.substr(0, name.lastIndexOf('/'));
// console.log('testing', child_collection_name);
  if(child_collection_name.includes('XXS') || child_collection_name.includes('XS')  || child_collection_name.includes('S')){
var href = $(this).data("href");
// console.log(href);
var contain = name.includes(color);
if(contain == true){
var stock = $(this).attr("data-id");
if(stock == "true"){
stock_avil = 1;
var select_box_text_final =$(this).text().split("/");
select_box_text += "<li><a href="+href+"><div class='size-variants'>"+select_box_text_final[0]+ "<span class='Last--Hiffin'>"+'-'+"</span></div></a></li>";
$(".ProductItem__Wrapper").find(".variants-name").show();
  $(".ProductItem__Wrapper").find(".ProductItem__sizeSwatchList").hide();
$(".ProductItem[data-id="+id+"]").find(".sold_out_product").hide();
}
}
  }

});

 }
  else if (collection_url_adults == true || collection_url_adultst == true ) {
  console.log('adult');
    
    $(this).parent().find(".variants-wrapper select option").each(function(){
var name = $(this).text();
//console.log('sssssssss', name);
var adult_collection_name = name.substr(0, name.lastIndexOf('/'));
//  console.log('ggggggggggggggg', adult_collection_name);
  if(adult_collection_name.includes('XXS') || adult_collection_name.includes('XS')  || adult_collection_name.includes('S')){
//  console.log('oopppppppp');   

  }
else{
var href = $(this).data("href");
// console.log(href);
var contain = name.includes(color);
if(contain == true){
var stock = $(this).attr("data-id");
if(stock == "true"){
stock_avil = 1;
var select_box_text_final =$(this).text().split("/");
select_box_text += "<li><a href="+href+"><div class='size-variants'>"+select_box_text_final[0]+ "<span class='Last--Hiffin'>"+'-'+"</span></div></a></li>";
$(".ProductItem__Wrapper").find(".variants-name").show();
$(".ProductItem__Wrapper").find(".ProductItem__sizeSwatchList").hide();
$(".ProductItem[data-id="+id+"]").find(".sold_out_product").hide();
}
}  
  
}    

});
  
  }  
else{
   console.log('all');
  
$(this).parent().find(".variants-wrapper select option").each(function(){
var name = $(this).text();
//console.log('sssssssss', name);
var href = $(this).data("href");
// console.log(href);
var contain = name.includes(color);
if(contain == true){
var stock = $(this).attr("data-id");
if(stock == "true"){
stock_avil = 1;
var select_box_text_final =$(this).text().split("/");
select_box_text += "<li><a href="+href+"><div class='size-variants'>"+select_box_text_final[0]+ "<span class='Last--Hiffin'>"+'-'+"</span></div></a></li>";
$(".ProductItem__Wrapper").find(".variants-name").show();
  $(".ProductItem__Wrapper").find(".ProductItem__sizeSwatchList").hide();
$(".ProductItem[data-id="+id+"]").find(".sold_out_product").hide();
}
}
});
}
  
var select_box_text_final =select_box_text.slice(0,-1)
$(this).parents(".ProductItem__Wrapper").find('.variants-name').html(select_box_text_final);
if(stock_avil == 0){
  console.log('sold out test');
$(".ProductItem[data-id="+id+"]").find(".sold_out_product").show();

}
});
});

$(document).ready(function(){
  $('.collection-page-custom-color input:checked').each(function(){
    $(this).trigger('click');
    var url = $(this).attr('data-image-url');
    $(this).parents('.ProductItem__Wrapper').find('.ProductItem__Image').attr('src',url);
  });
});

